import React from "react";
import styled from "styled-components";

const StatusColorAndText = {
  "in progress": {
    bgColor: "#F0ECFA",
    textColor: "#6C2EF2",
    text: "In Progress",
  },
  completed: {
    bgColor: "#DDF4E5",
    textColor: "#159E43",
    text: "Completed",
  },
  missed: {
    bgColor: "#FFE4E4",
    textColor: "#FE2424",
    text: "Missed",
  },
  "to do": {
    bgColor: "#E6EEFD",
    textColor: "#2266EF",
    text: "To Do",
  },
  "ready to dispatch": {
    bgColor: "#2266EF",
    textColor: "#FFFFFF",
    text: "Ready to Dispatch",
  },
  "partially complete": {
    bgColor: "#FFA500",
    textColor: "#FFFFFF",
    text: "Partially Complete",
  },

  "totally missed": {
    bgColor: "#EB5757",
    textColor: "#FFFFFF",
    text: "Totally Missed",
  },
  late: {
    bgColor: "#EB5757",
    textColor: "#FFFFFF",
    text: "Late",
  },
  scheduled: {
    bgColor: "#2266EF",
    textColor: "#FFFFFF",
    text: "Scheduled",
  },
  unscheduled: {
    bgColor: "#A0A0A0",
    textColor: "#FFFFFF",
    text: "Unscheduled",
  },

  approved: {
    bgColor: "#DDF4E5",
    textColor: "#159E43",
    text: "Approved",
  },
  pending: {
    bgColor: "#FCEECA",
    textColor: "#BF8D03",
    text: "Pending",
  },
  rejected: {
    bgColor: "#FFE4E4",
    textColor: "#FE2424",
    text: "Rejected",
  },
  done: {
    bgColor: "#DDF4E5",
    textColor: "#159E43",
    text: "Done",
  },
  "not done": {
    bgColor: "#FFE4E4",
    textColor: "#DDF4E5",
    text: "Not Done",
  },
  "open": {
    bgColor: "#A0A0A0",
    textColor: "#FFFFFF",
    text: "Open",
  },
  "in_progress": {
    bgColor: "#F0ECFA",
    textColor: "#6C2EF2",
    text: "In Progress",
  },
  "complete": {
    bgColor: "#DDF4E5",
    textColor: "#159E43",
    text: "Complete",
  },
  "completed": {
    bgColor: "#DDF4E5",
    textColor: "#159E43",
    text: "Completed",
  },
  
    
};

const StatusDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ textColor }) => textColor || "#FFFFFF"};
  margin-right: 6px;
`;

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px 5px 10px;
  border-radius: 10px;
  font-weight: 600;
  background-color: ${({ status }) => {
    if (!status) return "#A0A0A0";
    const normalizedStatus = status.toLowerCase();
    return StatusColorAndText[normalizedStatus]?.bgColor || "#A0A0A0";
  }};
  color: ${({ status }) => {
    if (!status) return "#FFFFFF";
    const normalizedStatus = status.toLowerCase();
    return StatusColorAndText[normalizedStatus]?.textColor || "#FFFFFF";
  }};
  width: max-content;
`;

const Status = ({ status, showDot = false }) => {
  if (!status) {
    return <StatusContainer status={null}>-</StatusContainer>;
  }

  const normalizedStatus = status.toLowerCase();
  const statusConfig = StatusColorAndText[normalizedStatus];
  const displayText = statusConfig?.text || status;
  const textColor = statusConfig?.textColor || "#FFFFFF";

  return (
    <StatusContainer status={normalizedStatus}>
      {showDot && <StatusDot textColor={textColor} />}
      {displayText}
    </StatusContainer>
  );
};

export default Status;
